import React, { useEffect, useRef, useState } from "react";
import type { ICountry } from "@/models";
import useMasterDataState from "@/stores/MasterDataState";

const DEFAULT_COUNTRY_CODE = "SG";

const _PhonePickerAdmissionController = (phoneNumber: string, countryCodeValue: string) => {
  const _getContactByCountryCode = (code: string, data: ICountry[]): ICountry | undefined => {
    const currentCode = data.find((el) => el.code === code);
    return currentCode ? currentCode : data.find((el) => el.code === DEFAULT_COUNTRY_CODE);
  };
  const [searchValue, setSearchValue] = React.useState("");

  const [phoneInputValue, setPhoneInputValue] = useState<string>("");
  const masterDataState = useMasterDataState();

  const [contact, setContact] = useState<ICountry | undefined>(
    _getContactByCountryCode(countryCodeValue, masterDataState.nationality),
  );

  const [isOpen, setOpen] = useState(false);
  const [isTopPosition, setIsTopPosition] = useState<boolean>(false);
  const dropdownRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const phoneNumberNoHyphens = phoneNumber.replace(/-/g, "");
    const findContact = _getContactByCountryCode(countryCodeValue, masterDataState.nationality);
    const dialCodeNoHyphen = findContact?.dialCode?.replace(/-/g, "") ?? "";
    const phoneWithoutDialCode = phoneNumberNoHyphens.replace(dialCodeNoHyphen, "").trim();
    setPhoneInputValue(phoneWithoutDialCode);
    if (phoneWithoutDialCode) {
      setContact(_getContactByCountryCode(countryCodeValue, masterDataState.nationality));
    }
  }, [phoneNumber, countryCodeValue, masterDataState.nationality, _getContactByCountryCode]);

  const _handleToggleDropdown = () => {
    setOpen((prev) => !prev);
    calculatePosition();
  };

  const handleClickOutside = (event: MouseEvent) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
      setOpen(false);
    }
  };

  const calculatePosition = () => {
    const clickedElement = dropdownRef.current;

    if (clickedElement) {
      const viewportHeight = window.innerHeight;

      const spaceBelow = viewportHeight - clickedElement.getBoundingClientRect().bottom;
      const spaceAbove = clickedElement.getBoundingClientRect().top;
      if (spaceBelow >= clickedElement.clientHeight + 80 || spaceBelow >= spaceAbove) {
        setIsTopPosition(false);
      } else {
        setIsTopPosition(true);
      }
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [handleClickOutside]);

  return {
    isOpen,
    contact,
    setContact,
    dropdownRef,
    searchValue,
    isTopPosition,
    setSearchValue,
    phoneInputValue,
    setPhoneInputValue,
    _handleToggleDropdown,
  };
};

export default _PhonePickerAdmissionController;
